import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@material-ui/core";
import { formatAmount } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";

const CibilObligationsDialog = ({ open, onClose, obligations = [] }) => {
  const data = obligations.filter((item) => item.included);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>CIBIL Obligations</DialogTitle>

      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Loan Type</TableCell>
              <TableCell align="right">Sanction Amount</TableCell>
              <TableCell align="right">POS</TableCell>
              <TableCell align="right">ROI (%)</TableCell>
              <TableCell align="right">Tenor</TableCell>
              <TableCell align="right">Remaining Tenure</TableCell>
              <TableCell>Basis</TableCell>
              <TableCell align="right">Installment</TableCell>
              <TableCell align="right">Monthly Obligation</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.loanType}</TableCell>
                <TableCell align="right">
                  {formatAmount(row.sanctionAmount, true)}
                </TableCell>
                <TableCell align="right">
                  {formatAmount(row.pos, true)}
                </TableCell>
                <TableCell align="right">{row.roi}</TableCell>
                <TableCell align="right">{row.tenor}</TableCell>
                <TableCell align="right">
                  {row.remainingTenure}
                </TableCell>
                <TableCell>{removeUnderscores(row?.basis)}</TableCell>
                <TableCell align="right">
                  {formatAmount(row.installmentAmount, true)}
                </TableCell>
                <TableCell align="right">
                  {formatAmount(row.monthlyObligation, true)}
                </TableCell>
              </TableRow>
            ))}

            {data.length === 0 && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No obligations found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CibilObligationsDialog;